import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS, Permission } from '../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/explore/_externalProjectionsLayout/dashboards/edit/$id/')({
  validateSearch: zodValidator(withDefaults(schema.CUSTOM_DASHBOARDS, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!(
      context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.CUSTOM_DASHBOARDS }) ||
      context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.CUSTOM_DASHBOARDS, permission: Permission.UPDATE })
    );
    context.validatePermissions({ isAllowed, preload });
  },
});
